const HEADER_FREE_PATHS = [
  "/api/v1/users",
  "/api/v2/users",
  "/api/v2/user-mfa-devices",
  "/api/v1/workspace-invites/accept",
  "/api/v1/notifications",
  "/api/v1/agreements",
];

function asPathname(url) {
  if (!url) return "";

  try {
    return new URL(url, window.location.origin).pathname;
  } catch {
    return String(url).split("?")[0];
  }
}

export function isProviderPortalPath(pathname) {
  // Provider portal routes are legacy v1/v2 endpoints. v3 document-request routes are
  // workspace-admin APIs and must retain their session and tenancy headers.
  return /^\/api\/v[12]\/document-requests\/[^/]+\/[^/]+\//.test(pathname);
}

export function isProviderPortalRequest(url) {
  return isProviderPortalPath(asPathname(url));
}

export function isPublicAuthRequest(url) {
  const pathname = asPathname(url);
  return (
    pathname === "/api/v1/workspace-invites/accept" ||
    pathname === "/api/v2/users/login" ||
    pathname === "/api/v2/users/signup"
  );
}

export function isWorkspaceScopedRequest(url) {
  const pathname = asPathname(url);

  if (!pathname || HEADER_FREE_PATHS.some((path) => pathname.startsWith(path))) return false;
  if (isProviderPortalPath(pathname)) return false;

  return /^\/api\/(v2|v3)\//.test(pathname) || /^\/api\/v1\/(workspaces|workspace-)/.test(pathname);
}
